import { useEffect } from 'react';

export function useActionOnKeydown(
  isActive: boolean,
  onKeydownCallback: () => void,
  keys: string[] = ['Escape'],
) {
  useEffect(() => {
    if (!isActive) return;

    function onKeyDown(e: KeyboardEvent) {
      if (keys.includes(e.key as string)) {
        onKeydownCallback();
      }
    }

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isActive, onKeydownCallback, keys]);
}
